import { organizationProducts } from './products/organization';
import { enterpriseProducts } from './products/enterprise';
import { Product } from './types';
import { FeatureSet } from './feature-set';

class OrganizationFeatureSet extends FeatureSet {
  constructor(organizationProducts: Product[]) {
    super(organizationProducts, new Set(['logo']));
  }
}

export const OrganizationFeatures = new OrganizationFeatureSet(
  organizationProducts.concat(enterpriseProducts),
);
